import { render, staticRenderFns } from "./JImportModal.vue?vue&type=template&id=73c42a6b&scoped=true&"
import script from "./JImportModal.vue?vue&type=script&lang=js&"
export * from "./JImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c42a6b",
  null
  
)

export default component.exports